import { render, staticRenderFns } from "./marquee.vue?vue&type=template&id=b9a30628&scoped=true"
import script from "./marquee.vue?vue&type=script&lang=js"
export * from "./marquee.vue?vue&type=script&lang=js"
import style0 from "./marquee.vue?vue&type=style&index=0&id=b9a30628&prod&lang=less"
import style1 from "./marquee.vue?vue&type=style&index=1&id=b9a30628&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a30628",
  null
  
)

export default component.exports